var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.35938 1.3125 0 3 0H10.5V6C10.5 6.84375 11.1562 7.5 12 7.5H18V9.32812C14.5312 10.3125 12 13.5 12 17.25C12 20.0625 13.3594 22.5 15.4219 24C15.2812 24 15.1406 24 15 24H3C1.3125 24 0 22.6875 0 21V3ZM12 6V0L18 6H12ZM13.5 17.25C13.5 13.5469 16.5 10.5 20.25 10.5C23.9531 10.5 27 13.5469 27 17.25C27 21 23.9531 24 20.25 24C16.5 24 13.5 21 13.5 17.25ZM20.25 21.75C20.8594 21.75 21.375 21.2812 21.375 20.625C21.375 20.0156 20.8594 19.5 20.25 19.5C19.5938 19.5 19.125 20.0156 19.125 20.625C19.125 21.2812 19.5938 21.75 20.25 21.75ZM19.4531 13.5V17.25C19.4531 17.6719 19.8281 18 20.2031 18C20.625 18 20.9531 17.6719 20.9531 17.25V13.5C20.9531 13.125 20.625 12.75 20.2031 12.75C19.8281 12.75 19.4531 13.125 19.4531 13.5Z",
    fill: "#F67924"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.be8f8c6e711c043facfde015546d249a.svg";
export { ForwardRef as ReactComponent };